"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var NativeSafeAreaProvider_native_exports = {};
__export(NativeSafeAreaProvider_native_exports, {
  NativeSafeAreaProvider: () => NativeSafeAreaProvider
});
module.exports = __toCommonJS(NativeSafeAreaProvider_native_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var React = __toESM(require("react"), 1);
var import_react_native = require("react-native");
var import_safe_area = require("../platform/safe-area");
function NativeSafeAreaProvider(param) {
  var { children, style, onInsetsChange } = param;
  var handleInsetsChange = React.useCallback(function(param2) {
    var { nativeEvent } = param2;
    onInsetsChange({
      nativeEvent: (0, import_safe_area.providerEventToMetrics)(nativeEvent)
    });
  }, [
    onInsetsChange
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_safe_area.NativeSafeAreaProvider, {
    style: [
      styles.fill,
      style
    ],
    onNativeInsetsChange: handleInsetsChange,
    children
  });
}
var styles = import_react_native.StyleSheet.create({
  fill: {
    flex: 1
  }
});
//# sourceMappingURL=NativeSafeAreaProvider.native.js.map
